import {Component, inject, ViewChild} from '@angular/core';
import {CustomErrorComponent} from '../../../shared/custom-error.component';
import {FormsModule, NgForm} from '@angular/forms';
import {NgIf} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserManageGroupDto} from '../../../../generated-model/model';
import {filter} from 'rxjs/operators';
import {UserRest} from '../../../service/UserRest';
import {ConfirmDialogService} from '../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service';
import {ToastService} from '../../../shared/commons/toast/toast-service';
import {emailPattern, updateFormAndValidity} from '../../../app.constants';

@Component({
  selector: 'app-manager-user-modal-edit',
  standalone: true,
  imports: [
    FormsModule,
    NgIf,
    CustomErrorComponent
  ],
  templateUrl: './manager-user-modal-edit.component.html',
  styleUrl: './manager-user-modal-edit.component.scss'
})
export class ManagerUserModalEditComponent {
  @ViewChild('form') public ngForm: NgForm;
  prefix = '';
  userManageGroupDto: UserManageGroupDto
  public activeModal = inject(NgbActiveModal);
  userService = inject(UserRest)
  confirmDialogService = inject(ConfirmDialogService)
  toastService = inject(ToastService)


  save() {
    let valid = updateFormAndValidity(this.ngForm);
    if (!valid) {
      this.toastService.showWarning('กรุณากรอกข้อมูลให้ครบถ้วน');
      return;
    }
    else{
      this.confirmDialogService.open({content: 'ยืนยันการบันทึกข้อมูล'})
        .pipe(filter(e => !!e))
        .subscribe({
          next: () => {
            this.userService.editUser(this.userManageGroupDto).subscribe({
              next: () => {
                this.activeModal.close(true); // ส่งค่า true เพื่อบอกหน้าก่อนหน้าว่าบันทึกสำเร็จ
                this.toastService.showSuccess('บันทึกข้อมูลสำเร็จ');
              },
              error: (error) => {
                const errorMessage = error?.error?.message || 'เกิดข้อผิดพลาดในการบันทึกข้อมูล';
                this.toastService.showDangerWithMessage(errorMessage);
                console.error('Error saving user data:', error);
              },
            });
          }
        });
    }
  }

  protected readonly emailPattern = emailPattern;
}
